import type { Product } from "./index";
export type ProductVariant = {
  id: string;
  label: string;
  family: Product;
  countries?: string[];
  regions?: string[];
  handling?: "chilled" | "hot";
};
const v = (
  family: Product,
  id: string,
  label: string,
  countries?: string[],
  regions?: string[],
  handling?: "chilled" | "hot",
): ProductVariant => ({ id, label, family, countries, regions, handling });
export const VARIANTS: ProductVariant[] = [
  v("fresh-juice", "orange-juice", "Orange juice"),
  v("fresh-juice", "apple-juice", "Apple juice"),
  v("fresh-juice", "mango-juice", "Mango juice"),
  v("fresh-juice", "pineapple-juice", "Pineapple juice"),
  v("fresh-juice", "mixed-fruit-juice", "Mixed fruit juice"),
  v("fresh-juice", "green-juice", "Vegetable / green juice"),
  v(
    "fresh-juice",
    "sugarcane-juice",
    "Sugarcane juice",
    ["IN"],
    undefined,
    "chilled",
  ),
  v("fresh-juice", "lime-drink", "Lime / nimbu drink", ["IN"]),
  v("fresh-juice", "coconut-water", "Packaged coconut water", [
    "IN",
    "TH",
    "ID",
    "PH",
    "MY",
    "SG",
    "BR",
    "AE",
  ]),
  v("fresh-juice", "calamansi-juice", "Calamansi juice", ["PH"]),
  v(
    "fresh-juice",
    "kokum-drink",
    "Kokum drink",
    ["IN"],
    ["Maharashtra", "Goa", "Karnataka"],
  ),
  v(
    "fresh-juice",
    "bel-pana",
    "Bel / bael pana",
    ["IN"],
    ["Odisha"],
    "chilled",
  ),
  v(
    "coffee-tea",
    "black-coffee",
    "Black coffee / Americano",
    undefined,
    undefined,
    "hot",
  ),
  v("coffee-tea", "espresso", "Espresso", ["IT"], undefined, "hot"),
  v("coffee-tea", "latte", "Latte", undefined, undefined, "hot"),
  v("coffee-tea", "cappuccino", "Cappuccino", undefined, undefined, "hot"),
  v("coffee-tea", "flat-white", "Flat white", ["AU", "NZ"], undefined, "hot"),
  v(
    "coffee-tea",
    "cold-brew",
    "Cold brew coffee",
    undefined,
    undefined,
    "chilled",
  ),
  v("coffee-tea", "iced-latte", "Iced latte", undefined, undefined, "chilled"),
  v("coffee-tea", "black-tea", "Black tea", undefined, undefined, "hot"),
  v("coffee-tea", "green-tea", "Green tea", undefined, undefined, "hot"),
  v("coffee-tea", "herbal-tea", "Herbal tea", undefined, undefined, "hot"),
  v("coffee-tea", "iced-tea", "Iced tea"),
  v("coffee-tea", "masala-chai", "Masala chai", ["IN"], undefined, "hot"),
  v(
    "coffee-tea",
    "ginger-chai",
    "Ginger / adrak chai",
    ["IN"],
    undefined,
    "hot",
  ),
  v(
    "coffee-tea",
    "filter-coffee",
    "South Indian filter coffee",
    ["IN"],
    ["Tamil Nadu", "Karnataka", "Kerala", "Andhra Pradesh", "Telangana"],
    "hot",
  ),
  v("coffee-tea", "matcha-tea", "Matcha tea", ["JP"]),
  v(
    "coffee-tea",
    "thai-iced-tea",
    "Thai iced tea",
    ["TH"],
    undefined,
    "chilled",
  ),
  v("coffee-tea", "teh-tarik", "Teh tarik", ["MY", "SG"], undefined, "hot"),
  v("coffee-tea", "kopi", "Kopi-style coffee", ["SG", "MY", "ID"]),
  v(
    "coffee-tea",
    "english-breakfast-tea",
    "English breakfast tea",
    ["GB"],
    undefined,
    "hot",
  ),
  v("coffee-tea", "cafe-au-lait", "Café au lait", ["FR"], undefined, "hot"),
  v("coffee-tea", "karak-chai", "Karak chai", ["AE", "SA"], undefined, "hot"),
  v(
    "protein-shakes",
    "whey-chocolate",
    "Chocolate whey shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "whey-vanilla",
    "Vanilla whey shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "protein-strawberry",
    "Strawberry protein shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "plant-protein",
    "Plant-based protein shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "lactose-free-protein",
    "Lactose-free protein shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "coffee-protein",
    "Coffee-flavoured protein shake",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "protein-shakes",
    "mango-protein",
    "Mango-flavoured protein shake",
    ["IN"],
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "plain-yoghurt",
    "Plain yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "greek-yoghurt",
    "Greek-style yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "fruit-yoghurt",
    "Fruit yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "protein-yoghurt",
    "Higher-protein yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "plant-yoghurt",
    "Plant-based yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "yoghurt",
    "drinkable-yoghurt",
    "Drinkable yoghurt",
    undefined,
    undefined,
    "chilled",
  ),
  v("yoghurt", "lassi", "Lassi", ["IN"], undefined, "chilled"),
  v("yoghurt", "chaas", "Chaas / buttermilk", ["IN"], undefined, "chilled"),
  v("yoghurt", "laban", "Laban", ["AE", "SA"], undefined, "chilled"),
  v(
    "yoghurt",
    "dahi-bara",
    "Dahi bara aloo dum (prepared portion)",
    ["IN"],
    ["Odisha"],
    "chilled",
  ),
  v("protein-bars", "chocolate-protein-bar", "Chocolate protein bar"),
  v("protein-bars", "nut-protein-bar", "Nut-based protein bar"),
  v("protein-bars", "plant-protein-bar", "Plant-based protein bar"),
  v("protein-bars", "muesli-bar", "Oat / muesli snack bar", ["AU", "NZ", "DE"]),
  v("protein-bars", "peanut-butter-bar", "Peanut-butter snack bar", ["US"]),
  v("protein-bars", "maple-oat-bar", "Maple oat snack bar", ["CA"]),
  v("nuts-seeds", "almonds", "Almonds"),
  v("nuts-seeds", "cashews", "Cashews"),
  v("nuts-seeds", "trail-mix", "Nut, seed and dried-fruit mix"),
  v("nuts-seeds", "roasted-chana", "Roasted chana", ["IN"]),
  v("nuts-seeds", "makhana", "Roasted makhana", ["IN"]),
  v("nuts-seeds", "peanuts", "Roasted peanuts"),
  v("nuts-seeds", "pumpkin-seeds", "Pumpkin / mixed seeds"),
  v("fruit", "banana", "Whole banana"),
  v("fruit", "apple", "Whole apple"),
  v("fruit", "seasonal-fruit", "Whole seasonal fruit"),
  v(
    "fruit",
    "cut-fruit",
    "Sealed cut-fruit cup",
    undefined,
    undefined,
    "chilled",
  ),
  v("fruit", "dried-fruit", "Dried-fruit portion"),
  v(
    "sandwiches-wraps",
    "vegetable-wrap",
    "Vegetable wrap",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "paneer-wrap",
    "Paneer wrap",
    ["IN"],
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "chicken-sandwich",
    "Chicken sandwich",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "hummus-wrap",
    "Hummus wrap",
    undefined,
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "baguette",
    "Filled baguette",
    ["FR"],
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "bocadillo",
    "Bocadillo-style sandwich",
    ["ES"],
    undefined,
    "chilled",
  ),
  v(
    "sandwiches-wraps",
    "onigiri",
    "Onigiri rice ball",
    ["JP"],
    undefined,
    "chilled",
  ),
  v("savoury-snacks", "baked-crisps", "Baked crisps / chips"),
  v("savoury-snacks", "popcorn", "Popcorn"),
  v("savoury-snacks", "crackers", "Wholegrain crackers"),
  v("savoury-snacks", "namkeen", "Packaged namkeen", ["IN"]),
  v("savoury-snacks", "banana-chips", "Banana chips", ["IN", "PH", "ID"]),
  v(
    "savoury-snacks",
    "murukku",
    "Murukku / chakli",
    ["IN"],
    [
      "Tamil Nadu",
      "Karnataka",
      "Kerala",
      "Andhra Pradesh",
      "Telangana",
      "Maharashtra",
    ],
  ),
  v("savoury-snacks", "khakhra", "Khakhra", ["IN"], ["Gujarat"]),
  v(
    "savoury-snacks",
    "dhokla",
    "Dhokla (prepared portion)",
    ["IN"],
    ["Gujarat"],
    "chilled",
  ),
  v(
    "savoury-snacks",
    "vada-pav",
    "Vada pav (prepared portion)",
    ["IN"],
    ["Maharashtra"],
    "hot",
  ),
  v(
    "savoury-snacks",
    "samosa",
    "Samosa (prepared portion)",
    ["IN"],
    undefined,
    "hot",
  ),
  v(
    "savoury-snacks",
    "idli",
    "Idli (prepared portion)",
    ["IN"],
    ["Tamil Nadu", "Karnataka", "Kerala", "Andhra Pradesh", "Telangana"],
    "hot",
  ),
  v(
    "savoury-snacks",
    "mudhi-mix",
    "Mudhi / puffed-rice snack mix",
    ["IN"],
    ["Odisha"],
  ),
  v(
    "savoury-snacks",
    "chakuli-pitha",
    "Chakuli pitha (prepared portion)",
    ["IN"],
    ["Odisha"],
    "hot",
  ),
  v("savoury-snacks", "pretzel", "Pretzel snack", ["DE"]),
  v("savoury-snacks", "rice-crackers", "Rice crackers", ["JP", "SG"]),
  v(
    "savoury-snacks",
    "pao-de-queijo",
    "Pão de queijo",
    ["BR"],
    undefined,
    "hot",
  ),
  v(
    "savoury-snacks",
    "kaya-toast",
    "Kaya toast portion",
    ["SG", "MY"],
    undefined,
    "hot",
  ),
  v("savoury-snacks", "seaweed-snack", "Seaweed snack", ["TH", "JP"]),
  v("chocolate", "dark-chocolate", "Dark chocolate"),
  v("chocolate", "milk-chocolate", "Milk chocolate"),
  v("chocolate", "small-chocolate", "Small chocolate portion"),
  v("chocolate", "peanut-butter-cups", "Peanut-butter cups", ["US"]),
  v("confectionery", "biscuits", "Biscuits / cookies"),
  v("confectionery", "stroopwafel", "Stroopwafel", ["NL"]),
  v("confectionery", "biscotti", "Biscotti", ["IT"]),
  v(
    "confectionery",
    "chhena-poda",
    "Chhena poda (sealed portion)",
    ["IN"],
    ["Odisha"],
    "chilled",
  ),
  v("confectionery", "khaja", "Khaja", ["IN"], ["Odisha"]),
  v(
    "confectionery",
    "poda-pitha",
    "Poda pitha (sealed portion)",
    ["IN"],
    ["Odisha"],
    "chilled",
  ),
  v("confectionery", "chikki", "Chikki / peanut brittle", ["IN"]),
  v(
    "coffee-tea",
    "kahwa",
    "Kahwa-style tea",
    ["IN"],
    ["Jammu and Kashmir", "Ladakh"],
    "hot",
  ),
  v(
    "yoghurt",
    "mishti-doi",
    "Mishti doi (sealed portion)",
    ["IN"],
    ["West Bengal"],
    "chilled",
  ),
  v(
    "savoury-snacks",
    "sattu-snack",
    "Sattu / roasted-gram snack",
    ["IN"],
    ["Bihar", "Jharkhand", "Uttar Pradesh"],
  ),
  v("savoury-snacks", "millet-snack", "Ragi / millet snack", ["IN"]),
  v(
    "savoury-snacks",
    "poha",
    "Poha (prepared portion)",
    ["IN"],
    ["Madhya Pradesh", "Maharashtra", "Chhattisgarh"],
    "hot",
  ),
  v(
    "savoury-snacks",
    "bhujia",
    "Packaged bhujia",
    ["IN"],
    ["Rajasthan", "Haryana", "Delhi", "Punjab"],
  ),
  v(
    "protein-shakes",
    "shelf-stable-shake",
    "Sealed shelf-stable protein shake (follow label)",
  ),
  v("confectionery", "shortbread", "Shortbread", ["GB"]),
  v("low-sugar-drinks", "unsweetened-drink", "Unsweetened drink"),
  v("low-sugar-drinks", "soy-drink", "Soy drink", ["JP", "SG", "MY"]),
  v("low-sugar-drinks", "sparkling-citrus", "Sparkling citrus drink", ["IT"]),
];
export const VARIANT_IDS = VARIANTS.map((v) => v.id);
export const VARIANT_LABELS = new Map(VARIANTS.map((v) => [v.id, v.label]));
const regionAliases: Record<string, string> = {
  gj: "gujarat",
  mh: "maharashtra",
  od: "odisha",
  or: "odisha",
  orissa: "odisha",
  tn: "tamilnadu",
  ka: "karnataka",
  kl: "kerala",
  ap: "andhrapradesh",
  ts: "telangana",
  wb: "westbengal",
  br: "bihar",
  up: "uttarpradesh",
  mp: "madhyapradesh",
  rj: "rajasthan",
  jk: "jammuandkashmir",
  cg: "chhattisgarh",
  jh: "jharkhand",
};
const normaliseRegion = (value: string) => {
  const key = value.toLowerCase().replace(/[^a-z]/g, "");
  return regionAliases[key] ?? key;
};
export function suggestedVariants(
  country: string,
  region: string,
  families: readonly string[],
  allCuisines = false,
) {
  return VARIANTS.filter(
    (v) =>
      families.includes(v.family) &&
      (allCuisines ||
        ((!v.countries || v.countries.includes(country)) &&
          (!v.regions ||
            !region.trim() ||
            v.regions.some(
              (r) => normaliseRegion(r) === normaliseRegion(region),
            )))),
  );
}
export const MARKET_PRESETS = {
  bhubaneswar: {
    country: "IN",
    region: "Odisha",
    city: "Bhubaneswar",
    currency: "INR",
    campaign: "bhubaneswar-pilot",
  },
} as const;
export function marketPreset(key: string | null) {
  return key === "bhubaneswar" ? MARKET_PRESETS.bhubaneswar : undefined;
}
